<div class="dockmates-container">
  <!-- Sticky Header: Sub Tabs + Search Bar -->
  <div class="dockmates-sticky-header">
    <!-- Sub Tabs -->
    <div class="tabs-inner-wrapper">
      <div class="sub-tabs">
        <button class="sub-tab" [appTourAnchor]="'captains.findTab'" [class.active]="activeTab === 'find'" (click)="setActiveTab('find')">
          Find
        </button>
        <button class="sub-tab" [appTourAnchor]="'captains.myTab'" [class.active]="activeTab === 'my-dockmates'" (click)="setActiveTab('my-dockmates')">
          My Dockmates
        </button>
        <button class="sub-tab" [appTourAnchor]="'captains.incomingTab'" [class.active]="activeTab === 'incoming'" (click)="setActiveTab('incoming')">
          Incoming
          <span class="badge" *ngIf="activeTab === 'incoming' && incomingCount > 0">{{
            formatCount(incomingCount)
            }}</span>
        </button>
        <button class="sub-tab" [appTourAnchor]="'captains.sentTab'" [class.active]="activeTab === 'sent'" (click)="setActiveTab('sent')">
          Sent
          <span class="badge" *ngIf="activeTab === 'sent' && sentCount > 0">{{
            formatCount(sentCount)
            }}</span>
        </button>
      </div>
    </div>
  </div>

  <div class="dockmates-content-wrapper">
    <!-- Title & Search Bar Row (scrolls with the cards, inside the card) -->
    <div class="header-action-row">
      <div class="search-bar" [appTourAnchor]="'captains.search'">
        <img class="search-icon" src="assets/home/profile/searchicon.svg" />
        <input type="text" [placeholder]="getSearchPlaceholder()" (input)="onSearchChange($event)"
          [value]="searchQuery" />
      </div>
    </div>
    <!-- Dockmates List -->
    <div class="mates-list" [appTourAnchor]="'captains.list'"
      [class.photo-grid]="activeTab === 'find' || activeTab === 'my-dockmates'"
      [class.request-grid]="activeTab === 'incoming' || activeTab === 'sent'">
      <ng-container *ngIf="loading && mates.length === 0">
      <div class="mate-card photo-card skeleton-card" *ngFor="let i of [1,2,3,4,5,6 , 7 ,8]">
        <div class="card-body-skeleton skeleton-shimmer"></div>
        <div class="card-body">
          <span class="skeleton-line skeleton-shimmer" style="width: 70%; height: 16px;"></span>
          <span class="skeleton-line skeleton-shimmer" style="width: 50%; height: 12px; margin-top: 8px;"></span>
          <span class="skeleton-line skeleton-shimmer" style="width: 90%; height: 12px; margin-top: 8px;"></span>
          <span class="skeleton-line skeleton-shimmer" style="width: 100%; height: 32px; margin-top: 12px; border-radius: 8px;"></span>
        </div>
      </div>
    </ng-container>

      <ng-container *ngFor="let mate of displayMates">

        <!-- ── Photo-first card for Find + My Dockmates ── -->
        <div class="mate-card photo-card" [class.is-removing]="mate.removing"
          *ngIf="activeTab === 'find' || activeTab === 'my-dockmates'"
          (click)="dockmateActionFromProfile(mate)">

          <div class="card-removing-overlay" *ngIf="mate.removing">
            <span class="btn-spinner btn-spinner--dark"></span>
            <span class="card-removing-text">Removing…</span>
          </div>

          <div class="card-photo">
            <img *ngIf="mate.image_url && !mate._avatarError" [src]="mate.image_url"
              class="photo-img" (error)="mate._avatarError = true" />
            <div *ngIf="!mate.image_url || mate._avatarError" class="photo-initials">
              {{ getInitials(mate.name) }}
            </div>
          </div>

          <div class="card-body">
            <span class="mate-name">{{ mate.name }}</span>

            <div class="mate-fleet">
              <img class="fleet-icon" src="assets/home/profile/boaticon.svg" />
              {{ (mate.vessel_name && mate.vessel_name !== 'No Vessel') ? mate.vessel_name : 'No vessel' }}
            </div>

            <div class="mutual-row" [class.clickable]="mate.mutual_connections_count > 0"
              (click)="openMutualConnections(mate, $event)">
              <div class="avatars-stack" *ngIf="mate.mutual_connections_count > 0">
                <ng-container *ngFor="let profile of getMutualProfiles(mate); let first = first">
                  <img *ngIf="profile.image_url" [src]="profile.image_url" [class.first-avatar]="first"
                    (error)="onMutualImgError($event)" />
                  <div *ngIf="!profile.image_url" class="mutual-avatar-fallback" [class.first-avatar]="first">
                    {{ profile.name ? getInitials(profile.name) : '' }}
                  </div>
                </ng-container>
                <div class="more-badge" *ngIf="mate.mutual_connections_count > 3">+{{ mate.mutual_connections_count - 3 }}</div>
              </div>
              <img src="assets/home/profile/no_mutual_icon.png" class="no-mutual-icon"
                *ngIf="mate.mutual_connections_count === 0" />
              <span class="mutual-text">{{ mate.mutual_connections_count }} Mutual
                {{ mate.mutual_connections_count === 1 ? 'Connection' : 'Connections' }}</span>
            </div>

            <!-- Find tab actions -->
            <ng-container *ngIf="activeTab === 'find'">
              <button class="card-action-btn btn-send-invite"
                *ngIf="!mate.direction && !mate.is_friend"
                (click)="sendRequest(mate); $event.stopPropagation()"
                [disabled]="mate.loading">
                <span *ngIf="mate.loading" class="btn-spinner"></span>
                <span *ngIf="!mate.loading">Send invite</span>
              </button>
              <button class="card-action-btn btn-pending"
                *ngIf="mate.direction === 'outgoing' && !mate.is_friend"
                (click)="$event.stopPropagation()">
                Pending
              </button>
              <button class="card-action-btn btn-friends" *ngIf="mate.is_friend"
                (click)="$event.stopPropagation()">
                Dockmates
              </button>
              <div class="dual-action-row" *ngIf="mate.direction === 'incoming' && !mate.is_friend">
                <button class="card-action-btn btn-ignore"
                  (click)="ignoreRequest(mate); $event.stopPropagation()" [disabled]="mate.loading">
                  <span *ngIf="mate.loading" class="btn-spinner btn-spinner--dark"></span>
                  <span *ngIf="!mate.loading">Ignore</span>
                </button>
                <button class="card-action-btn btn-accept"
                  (click)="acceptRequest(mate); $event.stopPropagation()" [disabled]="mate.loading">
                  <span *ngIf="mate.loading" class="btn-spinner"></span>
                  <span *ngIf="!mate.loading">Accept</span>
                </button>
              </div>
            </ng-container>

            <!-- My Dockmates: View profile + menu -->
            <div class="card-footer-row" *ngIf="activeTab === 'my-dockmates'">
              <button class="card-action-btn btn-view-profile"
                (click)="dockmateActionFromProfile(mate); $event.stopPropagation()">
                View profile
              </button>
              <button class="card-menu-btn" [matMenuTriggerFor]="mateMenu"
                (click)="$event.stopPropagation(); selectedMateForMenu = mate">
                <img src="assets/common_icons/threedots_icon.svg" />
              </button>
            </div>
          </div>
        </div>

        <!-- ── List card for Incoming + Sent ── -->
        <div class="mate-card request-card"
          *ngIf="activeTab === 'incoming' || activeTab === 'sent'"
          (click)="dockmateActionFromProfile(mate)">

          <div class="card-main-content">
            <div class="left-section">
              <div class="avatar-container">
                <img *ngIf="mate.image_url && !mate._avatarError" [src]="mate.image_url"
                  class="avatar" (error)="mate._avatarError = true" />
                <div *ngIf="!mate.image_url || mate._avatarError" class="avatar-initials">
                  {{ getInitials(mate.name) }}
                </div>
              </div>
              <div class="info">
                <div class="name-row">
                  <span class="name">{{ mate.name }}</span>
                  <span class="time-ago" *ngIf="mate.requested_at">{{ getTimeAgo(mate.requested_at) }}</span>
                </div>
                <div class="mutual" [class.clickable]="mate.mutual_connections_count > 0"
                  (click)="openMutualConnections(mate, $event)">
                  <div class="avatars-stack" *ngIf="mate.mutual_connections_count > 0">
                    <ng-container *ngFor="let profile of getMutualProfiles(mate); let first = first">
                      <img *ngIf="profile.image_url" [src]="profile.image_url" [class.first-avatar]="first"
                        (error)="onMutualImgError($event)" />
                      <div *ngIf="!profile.image_url" class="mutual-avatar-fallback" [class.first-avatar]="first">
                        {{ profile.name ? getInitials(profile.name) : '' }}
                      </div>
                    </ng-container>
                    <div class="more-badge" *ngIf="mate.mutual_connections_count > 3">+{{ mate.mutual_connections_count - 3 }}</div>
                  </div>
                  <img src="assets/home/profile/no_mutual_icon.png" class="mutual-icon-placeholder"
                    *ngIf="mate.mutual_connections_count === 0" />
                  <span class="mutual-connection">{{ mate.mutual_connections_count }} Mutual
                    {{ mate.mutual_connections_count === 1 ? 'Connection' : 'Connections' }}</span>
                </div>
                <div class="role-badge" *ngIf="mate.vessel_name && mate.vessel_name !== 'No Vessel'">
                  <img class="role-icon" src="assets/home/profile/boaticon.svg" />
                  {{ mate.vessel_name }}
                </div>
                <ng-container *ngIf="activeTab === 'incoming' && mate.message">
                  <span class="incoming-message">{{ mate.message }}</span>
                </ng-container>
              </div>
            </div>
          </div>

          <div class="bottom-actions">
            <button class="cancel-btn-full" *ngIf="activeTab === 'sent'"
              (click)="cancelRequest(mate); $event.stopPropagation()" [disabled]="mate.loading">
              <span *ngIf="mate.loading" class="btn-spinner btn-spinner--dark"></span>
              <span *ngIf="!mate.loading">Cancel Request</span>
            </button>
            <div class="request-actions-grid" *ngIf="activeTab === 'incoming'">
              <button class="ignore-btn-full" (click)="ignoreRequest(mate); $event.stopPropagation()"
                [disabled]="mate.loading">
                <span *ngIf="mate.loading" class="btn-spinner btn-spinner--dark"></span>
                <span *ngIf="!mate.loading">Ignore</span>
              </button>
              <button class="accept-btn-full" (click)="acceptRequest(mate); $event.stopPropagation()"
                [disabled]="mate.loading">
                <span *ngIf="mate.loading" class="btn-spinner"></span>
                <span *ngIf="!mate.loading">Accept</span>
              </button>
            </div>
          </div>
        </div>

      </ng-container>

      <div *ngIf="!loading && !hasMore && displayMates.length === 0" class="no-data">
        No members found
      </div>

      <!-- Infinite Scroll Loader -->
      <app-loader [loading]="loading && mates.length > 0" [overlay]="false"></app-loader>

      <!-- Scroll Sentinel (inside the scrolling list for infinite scroll) -->
      <div #scrollSentinel style="grid-column: 1 / -1; height: 1px; width: 100%"></div>
    </div>
  </div>

  <!-- Dockmates Menu -->
  <mat-menu #mateMenu="matMenu" class="dockmates-custom-menu">
    <button mat-menu-item (click)="dockmateActionFromProfile(selectedMateForMenu)" class="custom-menu-item">
      <img src="assets/common_icons/profile_icon.svg" class="menu-icon" />
      <span class="label">View Profile</span>
    </button>

    <button *ngIf="selectedMateForMenu?.is_friend" mat-menu-item (click)="removeConnection()"
      class="custom-menu-item delete">
      <img src="assets/common_icons/leave_icon.svg" class="menu-icon" />
      <span class="label">Remove Connection</span>
    </button>

    <button *ngIf="selectedMateForMenu?.is_friend || activeTab === 'my-dockmates'" mat-menu-item
      (click)="removeConnection()" class="custom-menu-item delete">
      <img src="assets/common_icons/leave_icon.svg" class="menu-icon" />
      <span class="label">Remove Connection</span>
    </button>
  </mat-menu>

  <!-- Profile Popup Modal -->
  <div class="profile-popup-overlay" *ngIf="showProfilePopup" (click)="closeProfile()">
    <div class="profile-popup-content" (click)="$event.stopPropagation()">
      <div class="profile-skeleton" *ngIf="profileLoading">
        <div class="skeleton-header">
          <div class="skeleton shimmer full-width height-140"></div>
          <div class="skeleton shimmer circle avatar-skeleton"></div>
        </div>
        <div class="profile-body-skeleton">
          <div class="skeleton shimmer text-line name-skeleton"></div>
          <div class="skeleton shimmer text-line stats-skeleton"></div>
          <div class="vessel-skeleton">
            <div class="skeleton shimmer text-line title-skeleton"></div>
            <div class="skeleton shimmer text-line row-skeleton"></div>
            <div class="skeleton shimmer text-line row-skeleton"></div>
          </div>
          <div class="skeleton shimmer button-skeleton"></div>
        </div>
      </div>

      <ng-container *ngIf="!profileLoading">
        <div class="profile-header">
          <img [src]="selectedProfile?.cover_image_url || 'assets/home/profile/banner_profile.webp'" class="cover-image" decoding="async" />
          <app-exit-button class="exit-btn-overlay" ariaLabel="Close profile"
            (clicked)="closeProfile()"></app-exit-button>
        </div>

        <div class="profile-body">
          <div class="profile-main-info">
            <div class="profile-avatar-wrapper">
              <img *ngIf="selectedProfile?.image_url" [src]="selectedProfile.image_url" class="profile-avatar" />
              <div *ngIf="!selectedProfile?.image_url" class="profile-avatar-initials">
                {{ getInitials(selectedProfile?.name) }}
              </div>
            </div>

            <div class="profile-info-side">
              <span class="profile-name">{{ selectedProfile?.name }}</span>
              <div class="profile-meta-stats">
                <span class="meta-item">
                  <img src="assets/common_icons/docks_model_icon.svg" />
                  {{ selectedProfile?.friends_count || 0 }} {{ selectedProfile?.friends_count <= 1 ? 'Dockmate'
                    : 'Dockmates' }} </span>
                    <span class="meta-item">
                      <img src="assets/home/profile/boaticon.svg" />
                      {{ selectedProfile?.communities_count || 0 }} {{ selectedProfile?.communities_count <= 1 ? 'Fleet'
                        : 'Fleets' }} </span>
              </div>
              <a href="javascript:void(0)" class="mutual-link">{{ selectedProfile?.mutual_connections_count || 0 }}
                mutual {{ (selectedProfile?.mutual_connections_count || 0) <= 1 ? 'dockmate' : 'dockmates' }}</a>

                  <!-- Phone Number -->
                  <div class="profile-phone" *ngIf="selectedProfile?.phone_number"
                    style="margin-top: 4px; display: flex; align-items: center; gap: 4px; font-family: Inter, sans-serif; font-weight: 590; font-size: 13px; line-height: 18px; letter-spacing: -0.08px; color: var(--Grays-Gray, hsla(240, 2%, 57%, 1));">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                      stroke-linecap="round" stroke-linejoin="round" style="opacity: 0.8;">
                      <path
                        d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                      </path>
                    </svg>
                    <span>{{ selectedProfile.phone_number }}</span>
                  </div>
            </div>
          </div>

          <div class="vessel-section"
            *ngIf="selectedProfile?.vessel_details || (selectedProfile?.vessel_name && selectedProfile?.vessel_name !== 'No Vessel')">
            <div class="vessel-header">
              <span class="vessel-title">{{
                selectedProfile?.vessel_details?.name || selectedProfile?.vessel_name || "No Vessel" }}</span>
              <span class="home-port" *ngIf="selectedProfile?.vessel_details?.home_port">
                <img src="assets/common_icons/docks_porticon.svg" />
                {{ selectedProfile?.vessel_details.home_port }}
              </span>
            </div>

            <div class="vessel-specs-grid">
              <div class="spec-row">
                <span class="spec-label">
                  {{ selectedProfile?.vessel_details?.manufacturer || 'N/A' }}
                </span>
                <span class="spec-value center">
                  {{ selectedProfile?.vessel_details?.draft?.value != null ? (selectedProfile.vessel_details.draft.value
                  + ' ' + (selectedProfile.vessel_details.draft.unit || 'ft')) : 'N/A' }} draft
                </span>
                <span class="spec-value right">
                  {{ selectedProfile?.total_distance != null ? selectedProfile.total_distance : '0.0' }} nmi
                </span>
              </div>
              <div class="spec-row">
                <span class="spec-label">
                  {{ selectedProfile?.vessel_details?.hull_color || 'N/A' | titlecase }}
                </span>
                <span class="spec-value center">
                  {{ selectedProfile?.vessel_details?.length_overall?.value != null ?
                  (selectedProfile.vessel_details.length_overall.value + ' ' +
                  (selectedProfile.vessel_details.length_overall.unit || 'ft')) : 'N/A' }} LOA
                </span>
                <span class="spec-value right">
                  {{ selectedProfile?.waypoints_count || 0 }} {{ (selectedProfile?.waypoints_count || 0) <= 1
                    ? 'waypoint' : 'waypoints' }} </span>
              </div>
            </div>
          </div>
          <div class="popup-actions" [ngSwitch]="activeTab">
            <ng-container *ngSwitchCase="'find'">
              <button *ngIf="!selectedProfile?.is_friend" class="action-btn"
                [class.cancel]="selectedProfile?.direction === 'outgoing'" (click)="toggleRequest(selectedProfile)"
                [disabled]="selectedProfile?.loading">
                {{ selectedProfile?.loading ? '...' : (selectedProfile?.direction === 'outgoing' ? 'Cancel Request' :
                'Add Friend' ) }}
              </button>
            </ng-container>

            <ng-container *ngSwitchCase="'my-dockmates'">
              <button class="action-btn" (click)="viewFullProfile()">
                View Full Profile
              </button>
            </ng-container>

            <ng-container *ngSwitchCase="'incoming'">
              <div class="dual-actions" *ngIf="!selectedProfile?.is_friend">
                <button class="ignore-btn-popup" (click)="ignoreRequest(selectedProfile)"
                  [disabled]="selectedProfile?.loading">Ignore</button>
                <button class="accept-btn-popup" (click)="acceptRequest(selectedProfile)"
                  [disabled]="selectedProfile?.loading">Accept</button>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'sent'">
              <button *ngIf="!selectedProfile?.is_friend" class="action-btn cancel"
                (click)="cancelRequest(selectedProfile)" [disabled]="selectedProfile?.loading">
                {{ selectedProfile?.loading ? '...' : 'Cancel Request' }}
              </button>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Invite Message Popup Overlay -->
  <div class="invite-popup-overlay" *ngIf="showInviteMessagePopup" (click)="cancelInvitePopup()">
    <div class="invite-popup-content" (click)="$event.stopPropagation()">
      <div class="invite-header">
        <h2 class="invite-title">Connect with {{ mateForInvite?.name }}</h2>
      </div>
      <div class="invite-body">
        <textarea class="message-input" placeholder="Enter a note (optional)" [(ngModel)]="inviteMessage"></textarea>
      </div>
      <div class="invite-actions">
        <button class="cancel-btn" (click)="cancelInvitePopup()">Cancel</button>
        <button class="send-btn" (click)="confirmSendRequest()" [disabled]="mateForInvite?.loading">
          {{ mateForInvite?.loading ? 'Sending...' : 'Send Request' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Mutual Connections list popup -->
  <div class="mutual-popup-overlay" *ngIf="showMutualPopup" (click)="closeMutualConnections()">
    <div class="mutual-popup" (click)="$event.stopPropagation()">
      <div class="mutual-popup-header">
        <h3>Mutual Connections</h3>
        <app-exit-button ariaLabel="Close mutual connections" (clicked)="closeMutualConnections()"></app-exit-button>
      </div>
      <div class="mutual-popup-list">
        <div class="mutual-popup-item" *ngFor="let p of mutualPopupProfiles">
          <img *ngIf="p.image_url" [src]="p.image_url" class="mutual-popup-avatar" (error)="onMutualImgError($event)" />
          <div *ngIf="!p.image_url" class="mutual-popup-avatar fallback">{{ p.name ? getInitials(p.name) : '' }}</div>
          <span class="mutual-popup-name">{{ p.name || 'Connection' }}</span>
        </div>
        <div class="mutual-popup-empty" *ngIf="mutualPopupProfiles.length === 0">
          {{ (mutualPopupMate?.mutual_connections_count || 0) }} mutual
          {{ (mutualPopupMate?.mutual_connections_count || 0) === 1 ? 'connection' : 'connections' }}
        </div>
      </div>
    </div>
  </div>

</div>